export enum ReferenceType {
  AllReferences = 0,
  Reservation = 1,
  Usage = 2,
  OfflineService = 3,
  ServiceRequest = 4,
  Subscription = 5,
}
